import { TagCategory } from '~/shared/types/tag-category';
import { getLcn } from '~/utils/labeled-classnames';
import tagFilterLabel from './tagFilterLabel';

export default function ChartTagCategories({
  tagCategories,
  activeTagCategory,
  setActiveTagCategory,
  setActiveTagFilter,
  setActiveTagFilterLabel,
}: {
  tagCategories: TagCategory[],
  activeTagCategory: TagCategory
  setActiveTagCategory: (tagCategory: TagCategory) => void,
  setActiveTagFilter: (filter: string) => void,
  setActiveTagFilterLabel: (label: string) => void,
}) {
  const lcn = getLcn({
    chartTagCategories: 'flex gap-2',
    tagTab: 'px-4 py-2 rounded-t-lg cursor-pointer text-white',
    tagTabInactive: 'bg-gray-700 hover:bg-contrast',
    tagTabActive: 'bg-gray-500',
  });

  return (
    <div className={lcn.chartTagCategories}>
      {tagCategories.map(tagCategory => {
        let className = lcn.tagTab;
        className = className + (tagCategory.id === activeTagCategory.id ? lcn.tagTabActive : lcn.tagTabInactive);
        return (
          <button
            key={tagCategory.id}
            className={className}
            onClick={() => {
              setActiveTagFilter('');
              setActiveTagCategory(tagCategory);
              setActiveTagFilterLabel(tagFilterLabel(tagCategory));
            }}
          >
            {tagFilterLabel(tagCategory)}
          </button>
        )
      })}
    </div>
  );
}; 